"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Select = ({ options, onChange, value }) => {
    const handleChange = (e) => {
        onChange(e.target.value);
    };
    return ((0, jsx_runtime_1.jsx)("select", { className: "form-select bg-white", onChange: handleChange, value: value, children: options.map(option => ((0, jsx_runtime_1.jsx)("option", { value: option.value, children: option.label }, option.value))) }));
};
exports.Select = Select;
